import { TenantNotificationPayload } from '../tenant.notification.payload';
import { RoomKey } from '../socket.room.key';

export const MessageReliabilityRooms = {
    inboxMessages: (): RoomKey<TenantNotificationPayload> => ({ key: 'inbox-messages' }),
    outboxMessages: (): RoomKey<TenantNotificationPayload> => ({ key: 'outbox-messages' }),
};
